<!--div class="input" [ngClass]="validationClass" *ngIf=!inputDate-->
<div class="input" [ngClass]="validationClass">
  @if (name) {
    <span class="input-name">{{name}}</span>
  }
  @if (required) {
    <span class="required-red">*</span>
  }
  <div style="position:relative">
    @if (withImage) {
      <img src="../../../../content/images/Magnifier.svg" class="input-image" (click)="imageClicked.emit(value)">
    }
    <!--input type="text" (blur)="onSaveModel()" inputPattern [inputTypePattern]="inputTypePattern" (focus)="onSaveState()"
    class="input-component" [(ngModel)]="value" (keyup)="onChange()" [placeholder]="placeholder" [disabled]="!!disabled"
    [maxLength]="maxTextLength" mask="{{maskPattern}}"-->
    <input [type]="inputType" (blur)="onSaveModel()" inputPattern [inputTypePattern]="inputTypePattern" (focus)="onSaveState()"
      class="input-component" [(ngModel)]="value" (keyup)="onChange()" (input)="onChange()" [placeholder]="placeholder" [disabled]="!!disabled"
      [maxLength]="maxTextLength" [attr.data-testid]="testId">
    @if (showEye) {
      <img src='../../../../content/images/eye.svg' (click)="showHideValue()" class="show-hidden-value">
    }
    @if (hideValue && showEye && value) {
      <div class="hider">X</div>
    }
  </div>
</div>
